export function leadmagnetForm() {
	// Return early if pagetemplate is not equal to leadmagnet.
	if (!document.body.classList.contains('page-template-leadmagnet')) {
		return false;
	}

	let budgetString = '';
	let resultString = '';

	const init = () => {
		const budget = document.querySelector('.budget .gfield_radio');
		const objectives = document.querySelectorAll(
			'.objective .gfield_radio input'
		);
		const resultInput = document.querySelector('.result input');

		budget.addEventListener('change', () => {
			budgetString = document.querySelector('input:checked').value;

			objectives.forEach((objective) => {
				if (objective.checked === true) {
					objective.checked = false;
					resultString = '';
				}
			});

			resultInput.value = budgetString + resultString;
		});

		objectives.forEach((objective) => {
			objective.addEventListener('change', () => {
				budgetString = budget.querySelector('input:checked').value;

				if (objective.value !== '' && objective.value !== 'undefined') {
					resultString = '.' + objective.value;
				}

				resultInput.value = budgetString + resultString;
			});
		});
	};

	const scrollOnChoice = () => {
		const budget = document.querySelector('.budget .gfield_radio');

		budget.addEventListener('change', () => {
			// Use settimeout to put it last in the queue.
			setTimeout(() => {
				const objective = document.querySelector(
					'.objective[data-conditional-logic="visible"]'
				);

				// Use scrollIntoView() so we can use scroll 'scroll-margin-top' in css.
				objective.scrollIntoView({
					block: 'start',
					behavior: 'smooth',
				});
			}, 0);
		});
	};

	// eslint-disable-next-line no-undef
	jQuery(document).on('gform_post_render', function (event, formId) {
		const budget = document.querySelector('.gfield.budget');
		let leadmagnetFormId = budget.getAttribute('id');
		leadmagnetFormId = parseInt(leadmagnetFormId.split('_')[1]);

		/**
		 * Prevent the functions from executing more then once
		 * by checking if the formId matches the leadmagnet form id.
		 */
		if (formId === leadmagnetFormId) {
			init();
			scrollOnChoice();
		}
	});
}
